import React from 'react';
import { useTranslation } from 'react-i18next';
import { DrivingLicence, VerifyUserIcon } from '../../icons';
import './EntryStep.scss';
export const EntryStep = ({ onStart }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "entry-step" },
        React.createElement(VerifyUserIcon, { width: 64, height: 64 }),
        React.createElement("div", { className: "entry-step__inner-content" },
            React.createElement("h2", { className: "entry-step__inner-content__title" }, t('entryScreen.title')),
            React.createElement("div", { className: "entry-step__inner-content__description" },
                React.createElement("p", null, t('entryScreen.description')),
                React.createElement("p", null, t('entryScreen.verify_identity'))),
            React.createElement("div", { className: "entry-step__inner-content__licence-block" },
                React.createElement("div", { className: "entry-step__inner-content__licence-block__header" },
                    React.createElement("div", { className: "entry-step__inner-content__licence-block__header__title" },
                        React.createElement(DrivingLicence, { width: 23, height: 17 }),
                        React.createElement("h2", null, t('common.driving_license'))),
                    React.createElement("div", { className: "entry-step__inner-content__licence-block__header__badge" }, t('entryScreen.recommended'))),
                React.createElement("p", { className: "entry-step__inner-content__licence-block__description" }, t('entryScreen.driving_license_description'))),
            React.createElement("div", { className: "entry-step__inner-content__passport-block" },
                React.createElement("h2", null, t('entryScreen.passport_verify_identity')),
                React.createElement("p", null, t('entryScreen.passport_description')))),
        React.createElement("div", { className: "entry-step__footer" },
            React.createElement("button", { className: "entry-step__footer__button", onClick: onStart }, t('entryScreen.continue')))));
};
//# sourceMappingURL=EntryStep.js.map